<template>
  <div>
    <div v-if="currentPage === 2">
      <InformacaoPreparoInox
        :model="model"
        :isBusy="isBusy"
      />
      <LeituraMateriais
        :model="model"
        :isBusy="isBusy"
      />
    </div>
  </div>
</template>

<script>
import InformacaoPreparoInox from '../../Components/InformacoesPreparoInox';
import LeituraMateriais from '../../Components/LeituraMateriais';

export default {
  name: 'PreparoInox',
  components: {
    InformacaoPreparoInox,
    LeituraMateriais,
  },
  props: {
    model: {
      type: Object,
      required: true,
    },
    currentMaterialModel: {
      type: Object,
      required: true,
    },
    currentPage: {
      type: Number,
      required: true,
    },
    isBusy: {
      type: Boolean,
    },
    numberOfPages: {
      type: Number,
      required: true,
    },
  },
};
</script>
